import { swapOperator } from '../filterQueryFormat/operator/Operator';
import { useMemo, useState, useRef } from 'react';
import { useOperatorOptions } from './useOperatorOptions';
export const useLogicGroupRefinement = (field, filterFamily, onRefinementChange, refinement) => {
  const {
    options: operatorOptions,
    getOperatorByName
  } = useOperatorOptions(filterFamily, field);
  const [isChecked, setIsChecked] = useState(!!refinement);
  const defaultRefinement = useMemo(() => {
    const Operator = getOperatorByName(operatorOptions[0].value);
    return Operator.of(field);
  }, [field, getOperatorByName, operatorOptions]);
  const previousRefinement = useRef(defaultRefinement);
  const refinementCondition = useMemo(() => {
    return refinement || previousRefinement.current;
  }, [previousRefinement, refinement]);
  const operatorName = refinementCondition.constructor.toString();
  const onCheckboxChange = evt => {
    const newIsChecked = evt.target.checked;
    setIsChecked(newIsChecked);
    if (newIsChecked) {
      onRefinementChange(previousRefinement.current, false);
    } else {
      previousRefinement.current = refinementCondition.remove('errors');
      onRefinementChange();
    }
  };
  const onSelectedOptionChange = evt => {
    const newOperatorOption = evt.target.value;
    const Operator = getOperatorByName(newOperatorOption.value);
    const newCondition = swapOperator(Operator, refinementCondition);
    onRefinementChange(newCondition, false);
  };
  const onRefinementConditionValueChange = newCondition => {
    onRefinementChange(newCondition);
  };
  return {
    isChecked,
    onCheckboxChange,
    onRefinementConditionValueChange,
    onSelectedOptionChange,
    operatorName,
    operatorOptions,
    refinementCondition
  };
};